<div id="cms-blog-header-search">
  <div id="cms-blog-header-search-input-container" #searchInputContainer>
    <input
      id="cms-blog-header-search-input"
      #searchInput
      placeholder="Search"
      [class.mat-elevation-z2]="searchInputHasFocus"
      [class.show-magnifier]="!isNarrow"
      (focus)="onFocus()"
      (keyup)="onKeyup($event)"
      (keydown.enter)="onKeydownEnter()"
      data-cy="cms-blog-header-search-wide"
      />
    @if (!displayMagnifier && isNarrow) {
      <div id="cms-blog-header-search-narrow-close" (click)="navAway()">
        <div></div>
        <div></div>
      </div>
    }
  </div>

  @if (isActive) {
    <div id="cms-blog-header-search-menu" #searchMenu>
      @if (suggestedPosts.length == 0) {
        <div id="cms-blog-header-search-no-results">
          <h5 class="cms-blog-header-search-menu-title">No results match your search query.</h5>
        </div>
      }
      @if (suggestedPosts.length > 0) {
        <div id="cms-blog-header-search-menu-posts">
          @for (post of suggestedPosts; track post) {
            <div class="cms-blog-header-search-menu-posts-links">
              <a class="fx-row fx-row-h-left fx-row-v-center fx-wrap" [routerLink]="post.url" (click)="navAway()">
                <span class="mx-3 mt-1" [innerHTML]="post.title"></span>
                <p class="mx-3 mb-1 mt-base">{{ post.date }} &#x2022; {{ calculateReadingTime(post) }}</p>
              </a>
            </div>
          }
        </div>
      }
      @if (suggestedPosts.length > 0) {
        <div id="cms-blog-header-search-menu-see-more-results">
          <button
            class="button-primary see-more-button"
            id="cms-blog-header-search-menu-see-more-results-link"
            data-cy="cms-blog-search-menu-see-more-results"
            [routerLink]="'/blog/result/input/' + searchValue"
            (click)="navAway()"
            >
            See all results
          </button>
        </div>
      }
    </div>
  }
</div>
